// extracted by mini-css-extract-plugin
export default {"video":"wQZewuqAX0AzCor2dbjj"};